module.exports = __webpack_public_path__ + "static/media/UneeQ-logo.b03518ca.png";